import { useEffect } from "react"
import { DadosContainerDefault } from "../../components/Styles"
import Conquistas from "../../components/Conquistas"

function ConquistasPage() {

  useEffect(() => {
    document.title = 'Conquistas | Gesttor'
  }, [])

  return (
    <DadosContainerDefault>
      <Conquistas />
    </DadosContainerDefault>
  )
}

export default ConquistasPage